<template>
  <!--  <b-container-->
  <!--    v-if="-->
  <!--      corporation.bill_type ===-->
  <!--        'item'-->
  <!--    "-->
  <!--    fluid-->
  <!--  >-->
  <!--    <cash-document-component-->
  <!--      :add-document-handler="addDocumentHandler"-->
  <!--      :hospital-input.sync="hospitalSelected"-->
  <!--      :order-select-items.sync="orderSelectItems"-->
  <!--      :in-input.sync="inInput"-->
  <!--      :ti-input.sync="tiInput"-->
  <!--      :in-date.sync="inDate"-->
  <!--      :ti-date.sync="tiDate"-->
  <!--      :custom-hospital-input.sync="customHospitalInput"-->
  <!--      :view-type="viewType"-->
  <!--      :to-input.sync="toInput"-->
  <!--    />-->
  <!--  </b-container>-->
  <b-container class="bv-example-row pb-2" fluid>
    <b-row align-h="start" class="pb-1">
      <b-col class="p-0">
        <path-component :paths="paths" />
      </b-col>
    </b-row>
    <!--    <template v-if="viewType==='แก้ไขเอกสาร'">-->
    <!--      <b-row  class="p-2 justify-content-center">-->
    <!--        <b-col cols="auto">-->
    <!--          <b-card header="พิมพ์รายงาน">-->
    <!--            <b-row>-->
    <!--              <template v-for="(documentType, index) in corporation.documentTypes">-->
    <!--                <template v-if="documentType.has_number">-->
    <!--                  <b-col :key="index" cols="auto">-->
    <!--                    <b-button @click="printed(documentType.id)" variant="warning">-->
    <!--                      {{ documentType.name }}-->
    <!--                    </b-button>-->
    <!--                  </b-col>-->
    <!--                </template>-->
    <!--              </template>-->
    <!--            </b-row>-->
    <!--          </b-card>-->
    <!--        </b-col>-->
    <!--      </b-row>-->
    <!--    </template>-->

    <b-row align-h="between" class="p-3" style="background: #808080;">
      <b-col cols="auto" class="text-left">
        <h5 style="color: #FFF;">{{ viewType }}</h5>
      </b-col>
      <b-col>
        <b-row>
          <template v-if="viewType === 'แก้ไขเอกสาร'">
            <template
              v-for="(documentType, index) in corporation.documentTypes"
            >
              <template v-if="documentType.has_number">
                <b-col :key="index" cols="auto">
                  <b-row class="my-1">
                    <b-col>
                      <b-button
                        size="sm"
                        style="width: 250px;"
                        variant="warning"
                        @click="printed(documentType.id, false)"
                        >พิมพ์{{ documentType.name }} ฉบับจริง</b-button
                      >
                    </b-col>
                  </b-row>
                  <b-row class="my-1">
                    <b-col>
                      <b-button
                        size="sm"
                        style="width: 250px;"
                        variant="warning"
                        @click="printed(documentType.id, true)"
                        >พิมพ์{{ documentType.name }} สำเนา</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </template>
            </template>
          </template>
          <b-col cols="auto">
            <b-button
              type="reset"
              variant="danger"
              size="sm"
              class="px-5"
              @click="reset"
              >รีเซ็ต</b-button
            >
          </b-col>
          <b-col cols="auto">
            <b-button variant="success" size="sm" class="px-5" @click="submit"
              >บันทึก</b-button
            >
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-form>
      <b-row>
        <b-col cols="auto">
          <b-row class="py-2">
            <b-col cols="auto" class="my-auto">ชื่อลูกค้า</b-col>
            <b-col cols="auto" class="my-auto">
              <multiselect
                v-model="hospitalSelected"
                :options="allHospitals"
                label="name"
                track-by="id"
                select-label
                selected-label
                placeholder="เลือกสถานพยาบาล"
                :disabled="viewType === 'แก้ไขเอกสาร'"
                style="min-width: 250px;"
              />
              <!--              <b-form-select-->
              <!--                v-model="hospitalSelected"-->
              <!--                :disabled="viewType === 'แก้ไขเอกสาร'"-->
              <!--                text-field="name"-->
              <!--                value-field="id"-->
              <!--                :options="allHospitals"-->
              <!--                size="sm"-->
              <!--              >-->
              <!--                <template-->
              <!--                  slot="first"-->
              <!--                >-->
              <!--                  <option-->
              <!--                    v-if="corporation.bill_type === 'lab'"-->
              <!--                    :value="null"-->
              <!--                    disabled-->
              <!--                  >-->
              <!--                    เลือกสถานพยาบาล-->
              <!--                  </option>-->
              <!--                  <option-->
              <!--                    v-else-->
              <!--                    :value="null"-->
              <!--                  >-->
              <!--                    อื่นๆ-->
              <!--                  </option>-->
              <!--                </template>-->
              <!--              </b-form-select>-->
            </b-col>
          </b-row>
          <template
            v-if="!hospitalSelected && corporation.bill_type === 'item'"
          >
            <b-row class="py-2">
              <b-col class="my-auto">
                <b-form-input
                  id="customHospitalInput"
                  v-model="customHospitalInput.hospitalName"
                  placeholder="ชื่อลูกค้า"
                />
              </b-col>
            </b-row>
            <b-row class="py-2">
              <b-col class="my-auto">
                <b-form-textarea
                  id="customAddressInput"
                  v-model="customHospitalInput.hospitalAddress"
                  placeholder="ที่อยู่"
                />
              </b-col>
            </b-row>
            <b-row class="py-2">
              <b-col class="my-auto">
                <b-form-input
                  id="customPhoneInput"
                  v-model="customHospitalInput.hospitalPhoneNumber"
                  placeholder="เบอร์โทรศัพท์"
                />
              </b-col>
            </b-row>
          </template>
          <b-row class="py-2">
            <b-col cols="auto" class="my-auto">
              <label for="inInput">เลขที่เอกสาร</label>
            </b-col>
            <b-col cols="auto" class="my-auto">
              <b-form-input id="inInput" v-model="inInput" size="sm" />
            </b-col>
            <b-col cols="auto" class="my-auto">
              <label for="inDate">วันที่ออกเอกสาร</label>
            </b-col>
            <b-col cols="auto" class="my-auto">
              <datepicker
                id="inDate"
                v-model="inDate"
                input-class="form-control"
              />
            </b-col>
          </b-row>
          <template v-if="corporation.bill_type === 'item'">
            <b-row class="py-2">
              <b-col cols="auto">
                <b-form-checkbox
                  v-model="hasVat"
                  :value="true"
                  :unchecked-value="false"
                  >มี Vat</b-form-checkbox
                >
              </b-col>
            </b-row>
          </template>
          <template v-if="corporation.has_vat || hasVat">
            <b-row class="py-2">
              <b-col cols="auto" class="my-auto">
                <label for="tiInput">เลขที่ใบกำกับ</label>
              </b-col>
              <b-col cols="auto" class="my-auto">
                <b-form-input id="tiInput" v-model="tiInput" size="sm" />
              </b-col>
              <b-col cols="auto" class="my-auto">
                <label for="tiDate">วันที่ออกใบกำกับ</label>
              </b-col>
              <b-col cols="auto" class="my-auto">
                <datepicker
                  id="tiDate"
                  v-model="tiDate"
                  input-class="form-control"
                />
              </b-col>
            </b-row>
          </template>
          <b-row class="py-2">
            <b-col cols="auto">
              <label for="bankAccount">ธนาคารสำหรับออกบิล</label>
            </b-col>
            <b-col cols="auto">
              <b-form-select
                id="bankAccount"
                v-model="bankAccount"
                value-field="id"
                text-field="account_name"
                class="form-control"
                :options="bankAccountList"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="auto">
          <template v-if="corporation.bill_type === 'lab'">
            <b-row class="py-2">
              <b-col cols="auto" class="my-auto">
                <label for="promotionInput">โปรโมชั่น</label>
              </b-col>
              <b-col cols="auto">
                <multiselect
                  id="promotionInput"
                  v-model="promotionsSelected"
                  style="min-width: 200px;"
                  select-label
                  deselect-label="✖"
                  selected-label
                  :multiple="true"
                  label="name"
                  :options="promotions"
                  :taggable="true"
                  track-by="name"
                />
              </b-col>
            </b-row>
          </template>
          <template v-else>
            <b-row class="py-2">
              <b-col cols="auto" class="my-auto">
                <label for="discountInput" class="my-auto">ส่วนลด</label>
              </b-col>
              <b-col cols="auto" class="my-auto">
                <b-form-input
                  v-model="discountInput"
                  for="discountInput"
                  type="number"
                  min="0"
                />
              </b-col>
              <b-col cols="auto" class="my-auto">
                <b-form-group class="my-auto">
                  <b-form-radio-group
                    id="discountInput"
                    v-model="discountType"
                    name
                  >
                    <b-form-radio value="percent">%</b-form-radio>
                    <b-form-radio value="baht">บาท</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
          <b-row class="py-2">
            <b-col cols="auto" class="my-auto">
              <b-form-checkbox
                id="toInputCheck"
                v-model="toInputCheck"
                name="toInputCheck"
                :value="true"
                :unchecked-value="false"
                >ค่าขนส่ง</b-form-checkbox
              >
            </b-col>
            <b-col cols="auto" class="my-auto">
              <b-form-input v-model="toInput" type="number" min="0" />
            </b-col>
          </b-row>
          <!--          <b-row class="py-2">-->
          <!--            <b-col-->
          <!--              cols="auto"-->
          <!--              class="my-auto"-->
          <!--            >-->
          <!--              <b-form-checkbox-->
          <!--                id="withHoldingTax"-->
          <!--                v-model="withHoldingTax"-->
          <!--                name="withHoldingTax"-->
          <!--                :value="true"-->
          <!--                :unchecked-value="false"-->
          <!--              >-->
          <!--                หักภาษี ณ ที่จ่าย-->
          <!--              </b-form-checkbox>-->
          <!--            </b-col>-->
          <!--          </b-row>-->
          <b-row class="py-2">
            <b-col cols="auto" class="my-auto">
              <b-button
                variant="warning"
                @click="$refs['detailAddModal'].open()"
                >หมายเหตุเอกสาร</b-button
              >
              <sweet-modal ref="detailAddModal">
                <b-form>
                  <b-form-group
                    id="shipment-remark-label"
                    label="หมายเหตุ ใบส่งของ / ใบแจ้งหนี้"
                    label-for="shipment-remark-input"
                    class="text-left"
                  >
                    <b-form-input
                      id="shipment-remark-input"
                      v-model="shipmentRemark"
                      type="text"
                    />
                  </b-form-group>
                  <b-form-group
                    id="tax-remark-label"
                    label="หมายเหตุ ใบกำกับภาษี"
                    label-for="tax-remark-input"
                    class="text-left"
                  >
                    <b-form-input
                      id="tax-remark-input"
                      v-model="taxRemark"
                      type="text"
                    />
                  </b-form-group>
                  <b-form-group
                    id="billing-remark-label"
                    label="หมายเหตุ ใบวางบิล"
                    label-for="billing-remark-input"
                    class="text-left"
                  >
                    <b-form-input
                      id="billing-remark-input"
                      v-model="billingRemark"
                      type="text"
                    />
                  </b-form-group>
                  <b-form-group
                    id="receipt-remark-label"
                    label="หมายเหตุ ใบเสร็จรับเงิน"
                    label-for="receipt-remark-input"
                    class="text-left"
                  >
                    <b-form-input
                      id="receipt-remark-input"
                      v-model="receiptRemark"
                      type="text"
                    />
                  </b-form-group>
                  <div>
                    <b-button @click="$refs['detailAddModal'].close()"
                      >ปิด</b-button
                    >
                  </div>
                </b-form>
              </sweet-modal>
            </b-col>
            <!-- <b-col cols="auto">
              <b-form-group
                id="due-date-label"
                label="กำหนดวันชำระเงิน"
                class="text-left"
                label-for="due-date"
              >
                <b-input-group>
                  <flat-pickr
                    id="due-date"
                    v-model="dueDate"
                    :config="datePickerConfig"
                    class="form-control"
                    placeholder="คลิกเพื่อกำหนดวันชำระ"
                    name="due-date"
                  />
                  <b-button variant="danger" data-clear @click="dueDate = null">ล้าง</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>-->
          </b-row>
        </b-col>
        <!--        <b-col cols="auto">-->
        <!--          <b-row>-->
        <!--            <b-col>-->
        <!--              <b-row class="py-2">-->
        <!--                <b-col cols="auto">-->
        <!--                  <b-button-->
        <!--                    type="reset"-->
        <!--                    variant="danger"-->
        <!--                    size="sm"-->
        <!--                    class="px-5"-->
        <!--                    @click="reset"-->
        <!--                  >-->
        <!--                    รีเซ็ต-->
        <!--                  </b-button>-->
        <!--                </b-col>-->
        <!--                <b-col cols="auto">-->
        <!--                  <b-button-->
        <!--                    variant="success"-->
        <!--                    size="sm"-->
        <!--                    class="px-5"-->
        <!--                    @click="submit"-->
        <!--                  >-->
        <!--                    บันทึก-->
        <!--                  </b-button>-->
        <!--                </b-col>-->
        <!--              </b-row>-->
        <!--            </b-col>-->
        <!--          </b-row>-->
        <!--        </b-col>-->
      </b-row>
      <b-row>
        <b-col cols="lg-6">
          <b-card>
            <lab-invoice-table
              v-if="corporation.bill_type === 'lab'"
              :select-lab-invoice="selectLabInvoice"
              :lab-invoices-checks.sync="labInvoicesChecks"
              :is-busy.sync="isLabInvoiceBusy"
              :items.sync="labInvoices"
              :to-input-check="toInputCheck"
              :to-input="toInput"
              :with-holding-tax="withHoldingTax"
              :order-price="orderPrice"
              :promotions="promotionsSelected"
              :filter-lab-date.sync="filterLabDate"
              :filters="resetLabInvoices"
              :is-edit="viewType === 'แก้ไขเอกสาร'"
            />
            <item-invoice-table
              v-else
              :select-lab-invoice="selectLabInvoice"
              :lab-invoices-checks.sync="labInvoicesChecks"
              :is-busy.sync="isLabInvoiceBusy"
              :items.sync="items"
              :items-selected.sync="itemsSelected"
              :to-input-check="toInputCheck"
              :to-input="toInput"
              :with-holding-tax="withHoldingTax"
              :order-price="orderPrice"
              :discount-input="+discountInput"
              :discount-type="discountType"
              :filter-lab-date.sync="filterLabDate"
              :filters="resetLabInvoices"
            />
          </b-card>
        </b-col>
        <b-col cols="lg-6">
          <b-card>
            <lab-invoice-detail-table
              v-if="corporation.bill_type === 'lab'"
              :can-edit.sync="canLabDetailEdit"
              :is-busy.sync="isLabInvoiceDetailBusy"
              :items.sync="labInvoiceDetail"
              :lab-invoice-detail-checks.sync="labInvoiceDetailChecks"
              :delete-detail-handler="deleteDetailHandler"
              :detail-reset-handler="detailResetHandler"
              :save-detail-handler="saveDetailHandler"
              :ln="selectedLn"
              :specie-id="selectedSpecieId"
            />
            <item-invoice-detail-table
              v-else
              :is-busy.sync="isLabInvoiceDetailBusy"
              :items.sync="itemsSelected"
              :specie-id="selectedSpecieId"
            />
          </b-card>
        </b-col>
      </b-row>
    </b-form>

    <!--        <b-row class="p-2" v-if="viewType==='แก้ไขเอกสาร'">-->
    <!--            <b-col cols="auto" :key="documentType.id" v-for="documentType in documentTypes">-->
    <!--                <b-button style="width: 15rem;" class="btn-block " @click="printed(documentType.id)" variant="primary">{{ documentType.name }}</b-button>-->
    <!--            </b-col>-->
    <!--        </b-row>-->
    <!--        <b-row>-->
    <!--            <order-table-selection class="order-table" :orders="hospitalOrders" :orders-selected.sync="ordersSelected" />-->
    <!--        </b-row>-->
    <!--        <b-row align-h="end">-->
    <!--            <b-col cols="auto">-->
    <!--                <b-form-checkbox-->
    <!--                        id="can-edit"-->
    <!--                        v-model="canEdit"-->
    <!--                        name="can-edit"-->
    <!--                        :value="true"-->
    <!--                        :unchecked-value="false"-->
    <!--                >-->
    <!--                    สามารถแก้ไข-->
    <!--                </b-form-checkbox>-->
    <!--            </b-col>-->
    <!--        </b-row>-->
    <!--        <b-row>-->
    <!--            <test-table-selection class="test-table" :editable="canEdit" />-->
    <!--        </b-row>-->
  </b-container>
</template>

<script>
import PathComponent from "../../components/PathComponent";
import OrderTableSelection from "../../components/Account/OrderTableSelection";
import TestTableSelection from "../../components/Account/TestTableSelection";
import CashDocumentComponent from "../../components/Account/CashDocumentComponent";
import Datepicker from "vuejs-datepicker";
import { mapGetters, mapActions, mapState } from "vuex";
import LabInvoiceTable from "../../components/Account/LabInvoiceTable";
import LabInvoiceDetailTable from "../../components/Account/LabInvoiceDetailTable";
import ItemInvoiceTable from "../../components/Account/ItemInvoiceTable";
import ItemInvoiceDetailTable from "../../components/Account/ItemInvoiceDetailTable";
import { Thai } from "flatpickr/dist/l10n/th.js";
import flatpickr from "flatpickr";

export default {
  name: "DocumentView",
  components: {
    PathComponent,
    Datepicker,
    OrderTableSelection,
    TestTableSelection,
    CashDocumentComponent,
    LabInvoiceTable,
    LabInvoiceDetailTable,
    ItemInvoiceTable,
    ItemInvoiceDetailTable,
  },
  async created() {},
  computed: {
    ...mapGetters({
      corporation: "Account/getCorporationSelected",
      corporations: "Account/getPlatforms",
      hospitals: "Hospital/getAll",
      documentTypes: "Account/getFilterDocumentType",
      document: "Account/getDocumentDetail",
      platforms: "Account/getPlatforms",
    }),
    orderPrice() {
      let labChecks;
      if (this.corporation.bill_type === "lab") {
        labChecks = this.labInvoices.filter((labInvoice, index) =>
          this.labInvoicesChecks.includes(labInvoice.ln)
        );
        return labChecks.reduce((prev, curr) => prev + +curr.totalPrice, 0);
      } else if (this.corporation.bill_type === "item") {
        labChecks = this.itemsSelected;
        return labChecks.reduce(
          (prev, curr) => prev + +curr.price * +curr.quantity,
          0
        );
      } else {
        return 0;
      }
    },
    allHospitals() {
      if (this.corporation.platform_type === "other") {
        if (this.corporation.corporation_id) {
          return this.hospitals.filter(
            (hospital) =>
              hospital.corporation_id === this.corporation.corporation_id
          );
        }
        return this.hospitals;
      }

      return this.hospitals.filter(
        (hospital) => hospital.corporation_id === this.corporation.id
      );
    },
    hospitalOrders: {
      get() {
        return this.$store.state.Account.orders;
      },
      set(value) {
        this.$store.commit("Account/SET_ORDERS", value);
      },
    },
    ordersSelected: {
      get() {
        return this.$store.state.Account.ordersSelected;
      },
      set(value) {
        this.$store.commit("Account/SET_ORDERS_SELECTED", value);
      },
    },
    testsSelected: {
      get() {
        return this.$store.state.Account.testsSelected;
      },
      set(value) {
        this.$store.commit("Account/SET_TESTS_SELECTED", value);
      },
    },
    testsOrders: {
      get() {
        return this.$store.state.Account.tests;
      },
      set(value) {
        this.$store.commit("Account/SET_TESTS", value);
      },
    },
    corporationSelectedObject() {
      // if (this.)
      // return this.platforms.find(platform => platform.id === this.corporation)
    },
  },
  data() {
    return {
      filterLabDate: null,
      paths: [],
      viewType: "สร้างเอกสาร",
      hospitalSelected: null,
      inInput: null,
      inDate: null,
      tiInput: null,
      tiDate: null,
      canEdit: false,
      isLabInvoiceBusy: false,
      isLabInvoiceDetailBusy: false,
      labInvoices: [],
      labInvoiceDetail: [],
      labInvoiceDetailChecks: [],
      labInvoicesChecks: [],
      withHoldingTax: false,
      selectedLn: null,
      canLabDetailEdit: false,
      selectedSpecieId: null,
      orderSelectItems: [],
      promotionsSelected: [],
      toInput: 0,
      items: [],
      itemsSelected: [],
      toInputCheck: false,
      promotions: [],
      customHospitalInput: {
        hospitalName: "",
        hospitalAddress: "",
        hospitalPhoneNumber: "",
      },
      discountType: "percent",
      hasVat: false,
      discountInput: 0,
      shipmentRemark: "",
      taxRemark: "",
      receiptRemark: "",
      billingRemark: "",
      datePickerConfig: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: "d M Y",
        altInput: true,
        dateFormat: "U",
        locale: Thai, // locale for this instance only
      },
      flatpickr,
      dueDate: null,
      bankAccount: null,
      bankAccountList: [],
      // ordersSelected: [],
      // testsSelected: [],
      // testsOrders: []
    };
  },
  async mounted() {
    this.$store.state.isLoading = true;
    this.promotions = await this.getLabPromotions();
    this.bankAccountList = await this.getBankAccounts({
      corporationId: this.corporation.id,
      corporationType: this.corporation.platform_type,
    });
    this.bankAccount = this.bankAccountList.find((account) => account.default)
      ? this.bankAccountList.find((account) => account.default).id
      : this.bankAccountList.length > 0
      ? this.bankAccountList[0].id
      : null;

    this.$store.state.isLoading = false;
    if (this.$route.query.hasOwnProperty("id")) {
      await this.editViewInitialize();
    } else {
      await this.createViewInitialize();
    }

    this.paths = [
      {
        name: `ออกรายงาน ${this.corporation.name}`,
        path: "account",
        active: false,
      },
      {
        name: this.viewType,
        path: "document",
        active: true,
      },
    ];

    this.items = await this.getAllItems();
    if (this.viewType === "สร้างเอกสาร") {
      this.filterLabDate = new Date();
    }
    this.flatpickr = flatpickr(".flatpickr", this.datePickerConfig);
    // this.items = this.items.filter(item => )
  },
  methods: {
    ...mapActions({
      getOrders: "Order/getApproverOrderByHospital",
      generateIn: "Account/generateIn",
      generateTi: "Account/generateTi",
      createDocument: "Account/createDocument",
      editDocument: "Account/editDocument",
      setDocument: "Account/setDocument",
      resetDocument: "Account/resetDocuments",
      checkPermission: "Order/checkPermission",
      getOrderLabInvoice: "Account/getOrderLabInvoice",
      getOrderLabInvoiceByLN: "Account/getOrderLabInvoiceByLN",
      updateManualLabInvoiceDetail: "Account/updateManualLabInvoiceDetail",
      getLabPromotions: "Account/getLabPromotions",
      getAllItems: "Item/getAllItems",
      getItemInvoices: "Account/getItemInvoices",
      printDocument: "Account/printDocument",
      getBankAccounts: "Account/getBankAccounts",
    }),
    isDocumentHasTax() {
      return !!this.documentTypes.find((documentType) => {
        return documentType.name === "ใบกำกับภาษี";
      });
    },
    async permission(type, mod) {
      let permission = await this.checkPermission({
        type: type,
        mod: mod,
      });

      if (!permission) {
        this.$swal.fire("มีข้อผิดพลาดบางอย่าง", permission, "error");
        return false;
      }
      return true;
    },
    async addDocumentHandler() {
      // if (!this.hospitalSelected) {
      //   alert('กรุณากรอกสถานพยาบาล')
      //   return
      // }

      if (!this.inInput) {
        this.$swal.fire("กรุณากรอกเลขที่เอกสาร");
        return;
      }
      if (!this.inDate) {
        this.$swal.fire("กรุณากรอกวันที่ออกเอกสาร");
        return;
      }
      // if (this.isDocumentHasTax()) {
      //   if (!this.tiInput) {
      //     this.$swal.fire("กรุณากรอกเลขที่ใบกำกับ");
      //     return;
      //   }
      //   if (!this.tiInput) {
      //     this.$swal.fire("กรุณากรอกวันที่ออกใบกำกับ");
      //     return;
      //   }
      // }
      if (this.orderSelectItems.length === 0) {
        this.$swal.fire("กรุณาเพิ่มข้อมูลสิ่งสั่งตรวจ");
        return;
      }

      if (parseFloat(this.toInput) < 0) {
        this.$swal.fire("กรุณากรอกค่าขนส่งมากกว่าหรือเท่ากับ 0");
        this.toInput = 0;
        return;
      }

      let payload = {
        hospital_id: this.hospitalSelected ? this.hospitalSelected.id : null,
        customHospitalInput: this.customHospitalInput,
        in: this.inInput,
        ti: this.tiInput,
        tiDate: this.tiDate ? `${+this.tiDate}` : this.tiDate,
        orderSelectItems: this.orderSelectItems,
        carts: [],
        date: `${+this.inDate}`,
        corporationId: this.corporation.id,
        platformType: this.corporation.platform_type,
        dueDate: this.dueDate,
        to: this.toInput,
      };

      if (this.corporation.platform_type === "other") {
        if (
          !payload.customHospitalInput.hospitalName ||
          !payload.customHospitalInput.hospitalAddress ||
          !payload.customHospitalInput.hospitalPhoneNumber
        ) {
          this.$swal.fire("กรุณากรอกข้อมูลที่อยู่");
          return;
        }
      }

      let res =
        this.viewType === "สร้างเอกสาร"
          ? await this.createDocument(payload)
          : await this.editDocument({ id: this.$route.query.id, ...payload });

      if (res) {
        this.viewType = "แก้ไขเอกสาร";
        this.$router.push({
          name: "document",
          query: {
            id: res.id,
          },
        });
      }
    },
    async submit() {
      if (!this.hospitalSelected) {
        if (
          this.customHospitalInput.hospitalAddress === "" ||
          this.customHospitalInput.hospitalName === "" ||
          this.customHospitalInput.hospitalPhoneNumber === ""
        ) {
          await this.$swal.fire(
            "ข้อมูลไม่ถูกต้อง",
            "กรุณากรอกสถานพยาบาล",
            "warning"
          );
          return;
        }
      }
      if (!this.inInput) {
        await this.$swal.fire(
          "ข้อมูลไม่ถูกต้อง",
          "กรุณากรอกเลขที่เอกสาร",
          "warning"
        );
        return;
      }
      if (!this.inDate) {
        await this.$swal.fire(
          "ข้อมูลไม่ถูกต้อง",
          "กรุณากรอกวันที่ออกเอกสาร",
          "warning"
        );
        return;
      }
      if (this.toInputCheck) {
        this.toInput = +this.toInput;
        if (+this.toInput <= 0) {
          await this.$swal.fire(
            "ข้อมูลไม่ถูกต้อง",
            "กรุณากรอกค่าขนส่งหรือค่าขนส่งไม่ถูกต้อง",
            "warning"
          );
          return;
        }
      }
      // if (this.isDocumentHasTax() || this.hasVat) {
      //   if (!this.tiInput) {
      //     await this.$swal.fire(
      //       "ข้อมูลไม่ถูกต้อง",
      //       "กรุณากรอกเลขที่ใบกำกับ",
      //       "warning"
      //     );
      //     return;
      //   }
      //   if (!this.tiDate) {
      //     await this.$swal.fire(
      //       "ข้อมูลไม่ถูกต้อง",
      //       "กรุณากรอกวันที่ออกใบกำกับ",
      //       "warning"
      //     );
      //     return;
      //   }
      // }

      if (parseFloat(this.toInput) < 0) {
        await this.$swal.fire(
          "ข้อมูลไม่ถูกต้อง",
          "กรุณากรอกค่าขนส่งมากกว่าหรือเท่ากับ 0",
          "warning"
        );
        this.toInput = 0;
        return;
      }

      if (this.shipmentRemark) {
        if (this.shipmentRemark.length > 255) {
          await this.$swal.fire(
            "ข้อมูลไม่ถูกต้อง",
            "กรุณากรอกหมายเหตุใบส่งของ/ใบแจ้งหนี้ ต่ำกว่า 255 ตัวอักษร",
            "error"
          );
          return;
        }
      }
      if (this.taxRemark) {
        if (this.taxRemark.length > 255) {
          await this.$swal.fire(
            "ข้อมูลไม่ถูกต้อง",
            "กรุณากรอกหมายเหตุใบกำกับภาษี ต่ำกว่า 255 ตัวอักษร",
            "error"
          );
          return;
        }
      }
      if (this.billingRemark) {
        if (this.billingRemark.length > 255) {
          await this.$swal.fire(
            "ข้อมูลไม่ถูกต้อง",
            "กรุณากรอกหมายเหตุใบวางบิล ต่ำกว่า 255 ตัวอักษร",
            "error"
          );
          return;
        }
      }
      if (this.receiptRemark) {
        if (this.receiptRemark.length > 255) {
          await this.$swal.fire(
            "ข้อมูลไม่ถูกต้อง",
            "กรุณากรอกหมายเหตุใบเสร็จรับเงิน ต่ำกว่า 255 ตัวอักษร",
            "error"
          );
          return;
        }
      }

      if (this.corporation.bill_type === "lab") {
        for (const labInvoice of this.labInvoiceDetail) {
          if (+labInvoice.price <= 0) {
            await this.$swal.fire(
              "ข้อมูลไม่ถูกต้อง",
              "กรุณากรอกราคาผลตรวจให้มากกว่า 0",
              "error"
            );
            return;
          }
        }
      } else if (this.corporation.bill_type === "item") {
        if (this.itemsSelected.length <= 0) {
          await this.$swal.fire(
            "ข้อมูลไม่ถูกต้อง",
            "กรุณาเลือกสินค้าก่อนทำรายการ",
            "error"
          );
          return;
        }
      }

      this.$store.state.isLoading = true;

      let payload = {
        hospital_id: this.hospitalSelected ? this.hospitalSelected.id : null,
        in: this.inInput,
        ti: this.tiInput,
        to: this.toInput,
        date: `${this.inDate ? +this.inDate : null}`,
        tiDate: `${this.tiDate ? +this.tiDate : null}`,
        orderSelectItems: ordersSelected,
        corporationId: this.corporation.id,
        platformType: this.corporation.platform_type,
        dueDate: this.dueDate ? +this.dueDate : null,
        hasTo: this.toInputCheck,
        withHoldingTax: this.withHoldingTax,
        shipment_remark: this.shipmentRemark,
        tax_remark: this.taxRemark,
        billing_remark: this.billingRemark,
        receipt_remark: this.receiptRemark,
        corporation_account_id: this.bankAccount,
      };

      let filterCarts = [];
      let ordersSelected = [];

      if (this.corporation.bill_type === "lab") {
        ordersSelected = this.labInvoices.filter((labInvoice, index) =>
          this.labInvoicesChecks.includes(labInvoice.ln)
        );
        ordersSelected.forEach((order) => {
          filterCarts = filterCarts.concat(order.labInvoices);
        });

        if (ordersSelected.length <= 0) {
          await this.$swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่มีข้อมูลให้บันทึก กรุณาเลือก รายการ ก่อนบันทึก",
            "error"
          );
          this.$store.state.isLoading = false;
          return;
        }

        payload.promotions = this.promotionsSelected;
      } else if (this.corporation.bill_type === "item") {
        filterCarts = filterCarts.concat(this.itemsSelected);
        payload = {
          ...payload,
          discount_type: this.discountType,
          discount: this.discountInput,
          has_vat: this.hasVat,
          custom_hospital_input: this.customHospitalInput,
        };
      }

      payload = {
        ...payload,
        orderSelectItems: ordersSelected,
        carts: filterCarts,
      };

      let res =
        this.viewType === "สร้างเอกสาร"
          ? await this.createDocument(payload)
          : await this.editDocument({ id: this.$route.query.id, ...payload });

      if (res) {
        await this.$swal.fire("สำเร็จ", "ทำรายการสำเร็จ", "success");
        this.viewType = "แก้ไขเอกสาร";
        this.$store.state.isLoading = false;

        this.$router.push({
          name: "document",
          query: {
            id: res.id,
          },
        });

        if (this.corporation.bill_type === "lab") {
          await this.resetLabInvoices();
        }
      }
    },
    async createViewInitialize() {
      await this.resetDocument();
      this.hospitalOrders = [];
      this.ordersSelected = [];
      this.testsSelected = [];
      this.testsOrders = [];
      this.inInput = await this.generateIn();
      this.isDocumentHasTax() && (this.tiInput = await this.generateTi());
      let date = new Date();
      this.inDate = date;
      this.isDocumentHasTax() && (this.tiDate = date);
    },
    async editViewInitialize() {
      this.$store.state.isLoading = true;
      this.viewType = "แก้ไขเอกสาร";
      await this.setDocument(this.$route.query.id);
      this.inInput = this.document.in;
      this.inDate = new Date(this.document.created_date);
      this.toInput = this.document.to_amount;
      this.withHoldingTax = this.document.with_holding_tax;
      this.toInputCheck = this.document.including_shipment_price;
      this.promotionsSelected = this.document.promotionsSelected;
      this.hasVat = this.document.has_vat;
      this.shipmentRemark = this.document.shipment_remark;
      this.taxRemark = this.document.tax_remark;
      this.billingRemark = this.document.billing_remark;
      this.receiptRemark = this.document.receipt_remark;
      this.dueDate = this.document.due_date
        ? new Date(this.document.due_date)
        : null;
      this.bankAccount = this.document.corporation_account_id;

      if (this.isDocumentHasTax()) {
        this.tiInput = this.document.ti;
        this.tiDate = new Date(this.document.ti_created_date);
      }

      this.$nextTick(() => {
        this.hospitalSelected = this.allHospitals.find(
          (hospital) => hospital.id === this.document.hospital_id
        );
        if (this.corporation.bill_type === "lab") {
          if (
            this.allHospitals.filter(
              (hospital) => this.hospitalSelected.id === hospital.id
            ).length <= 0
          ) {
            this.$swal.fire("รายการไม่ตรงกับบริษัทที่เลือก");
            this.$store.state.isLoading = false;
            this.$router.push({ name: "account" });
          }
        }

        this.$nextTick(() => {
          this.labInvoices = this.document.labInvoices;
          if (this.labInvoices.length > 0) {
            this.filterLabDate = new Date(this.labInvoices[0].orderDate);
            // this.filterLabDate = moment(this.labInvoices[0].order_date)
          }
          // this.labInvoicesChecks = Object.keys(this.document.labInvoices).map(
          //   (index) => +index
          // );
          this.labInvoicesChecks = this.document.labInvoices.map(
            (index) => index.ln
          );
        });
      });

      this.customHospitalInput.hospitalName =
        this.document.custom_hospital_name || "";
      this.customHospitalInput.hospitalAddress =
        this.document.custom_hospital_address || "";
      this.customHospitalInput.hospitalPhoneNumber =
        this.document.custom_hospital_phone || "";
      this.discountInput = this.document.discount;
      this.discountType = this.document.discount_type;

      this.orderSelectItems = this.document.item_list;

      this.ordersSelected = this.document.orderLists.map((test) => test.id);
      this.itemsSelected = await this.getItemInvoices(this.document.id);

      this.$nextTick(() => {
        this.testsOrders = this.document.carts;
        this.testsSelected = this.document.carts.map((test) => test.test_id);
      });

      this.$store.state.isLoading = false;

      // this.hospitalOrders = await this.getOrders(this.document.hospital_id)
      // console.log(`set hospitalOrders by ${this.document.hospital_id}`, this.document)

      // this.$nextTick(() => {
      //   this.inInput = this.document.in
      //   this.inDate = new Date(this.document.created_date)
      //   this.toInput = this.document.to_amount
      //   if (this.isDocumentHasTax()) {
      //     this.tiInput = this.document.ti;
      //     this.tiDate = new Date(this.document.ti_created_date)
      //   }
      //
      //
      //   this.hospitalSelected = this.document.hospital_id
      //
      //   this.$nextTick(() => {
      //     this.customHospitalInput.hospitalName = this.document.custom_hospital_name || ''
      //     this.customHospitalInput.hospitalAddress = this.document.custom_hospital_address || ''
      //     this.customHospitalInput.hospitalPhoneNumber = this.document.custom_hospital_phone || ''
      //
      //     this.orderSelectItems = JSON.parse(this.document.item_list)
      //
      //     this.$nextTick(() => {
      //       this.ordersSelected = this.document.orderLists.map(test => test.id)
      //
      //       this.$nextTick(() => {
      //         this.testsOrders = this.document.carts
      //
      //         this.$nextTick(() => {
      //           this.testsSelected = this.document.carts.map(test => test.test_id)
      //         })
      //       })
      //     })
      //   })
      // })
    },
    async printed(id, isCopy = null) {
      let permission = await this.permission("accountant", "can_print");

      if (permission) {
        // alert(`printed document id: ${id}`);
        //  documentSelected
        // console.log(pageSetting)

        this.$store.state.isLoading = true;

        let printResponse;
        try {
          printResponse = await this.printDocument({
            documentSelected: id,
            id: this.$route.query.id,
            isCopy,
          });
        } catch (error) {
          this.$swal.fire("Error", error, "error");
          this.$store.state.isLoading = false;
          return;
        }

        this.$store.state.isLoading = false;
        window.open(printResponse.result.url);

        // window.open(`${process.env.VUE_APP_IP}document-print/${id}?id=${this.$route.query.id}`)

        // printJS({printable:`${process.env.VUE_APP_IP}document-print/${this.documentSelected}?id=${id}`, showModal:true})
      }
    },
    testFilter(newVal, oldVal = []) {
      let differentOrder = newVal
        .filter((x) => !oldVal.includes(x))
        .concat(oldVal.filter((x) => !newVal.includes(x)));
      // console.log(differentOrder, 'difference order')
      if (this.hospitalOrders.length <= 0) {
        if (differentOrder.length > 0) {
          this.ordersSelected = [];
        }
      } else {
        differentOrder.forEach((order) => {
          let existTest = this.testsOrders.find(
            (test) => test.order_id === order
          );
          if (existTest) {
            this.testsOrders = this.testsOrders.filter(
              (test) => test.order_id !== order
            );
            this.testsSelected = this.testsSelected.filter((testId) =>
              this.testsOrders.find((test) => test.test_id === testId)
            );
          } else {
            let orderObject = this.hospitalOrders.find(
              (rawOrder) => rawOrder.id === order
            );
            let newTests = orderObject.test_order.map((test) => ({
              test_id: test.id,
              order_id: order,
              ln: test.ln,
              patient: orderObject.animal_name,
              spp: orderObject.spp,
              test_item: test.test.name,
              price: test.test.price,
              quantity: 1,
              total_price: test.test.price,
              default_total_price: test.test.price,
              is_edit: false,
              approver: orderObject.latest_approve,
              remark: "",
            }));

            newTests.forEach((newTest) => {
              let testIndex = this.testsOrders.findIndex(
                (test) => test.test_id === newTest.test_id
              );

              if (testIndex > -1) {
                this.testsOrders[testIndex].quantity++;
                this.testsOrders[testIndex].total_price =
                  this.testsOrders[testIndex].price *
                  this.testsOrders[testIndex].quantity;
              } else {
                this.testsOrders.push(newTest);
                this.testsSelected.push(newTest.test_id);
              }
            });
          }
        });
      }
    },
    clearLabInvoices() {
      this.labInvoices = [];
      this.labInvoicesChecks = [];
      this.selectedLn = null;
      this.selectedSpecieId = null;
    },
    clearLabInvoiceDetail() {
      this.labInvoiceDetail = [];
      this.labInvoiceDetailChecks = [];
      this.canLabDetailEdit = false;
    },
    clearInput() {
      this.inInput = null;
      this.inDate = null;
      this.tiInput = null;
      this.tiDate = null;
      this.toInput = 0;
      this.withHoldingTax = null;
      this.toInputCheck = false;
    },
    reset() {
      this.hospitalSelected = null;
      this.clearInput();
      this.clearLabInvoices();
      this.clearLabInvoiceDetail();
    },
    async selectLabInvoice(value) {
      if (value.length > 0) {
        this.isLabInvoiceDetailBusy = true;
        this.selectedLn = value[0].ln;
        this.selectedSpecieId = +value[0].specieId;
        this.labInvoiceDetail = await this.getOrderLabInvoiceByLN({
          ln: this.selectedLn,
          documentId: this.$route.query.id,
          date: this.filterLabDate,
        });
        this.canLabDetailEdit = false;
        this.isLabInvoiceDetailBusy = false;
      } else {
        this.labInvoiceDetail = [];
      }
    },
    async deleteDetailHandler() {
      const confirm = await this.$swal.fire({
        title: "ยืนยันการลบ",
        text: "คุณต้องการลบที่รายการที่เลือกใช่หรือไม่?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบ",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      });

      if (confirm.value) {
        this.labInvoiceDetail = this.labInvoiceDetail.filter(
          (detail, index) => !this.labInvoiceDetailChecks.includes(index)
        );
        this.labInvoiceDetailChecks = [];
      }
    },
    async detailResetHandler() {
      this.clearLabInvoiceDetail();

      this.$nextTick(async () => {
        this.labInvoiceDetail = await this.getOrderLabInvoiceByLN({
          ln: this.selectedLn,
          documentId: this.$route.query.id,
          date: this.filterLabDate,
        });
      });
    },
    saveDetailHandler: async function() {
      if (
        this.labInvoiceDetail.filter((labInvoice) => !labInvoice.price).length >
        0
      ) {
        await this.$swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณากรอกราคาให้ครบทุกผลตรวจ",
          "error"
        );
        return;
      }

      const confirm = await this.$swal.fire({
        title: "ยืนยันการบันทึก",
        text: "บันทึกรายการที่แก้ไขไปใช่หรือไม่",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            const data = {
              ln: this.selectedLn,
              payload: this.labInvoiceDetail,
            };
            return this.updateManualLabInvoiceDetail(data);
          }
        },
      });

      if (confirm.value) {
        try {
          this.labInvoices = await this.getOrderLabInvoice({
            hospitalId: this.hospitalSelected ? this.hospitalSelected.id : null,
            documentId: this.$route.query.id,
            date: this.filterLabDate,
          });
        } catch (e) {
          await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
          this.isLabInvoiceBusy = false;
        }

        let checkLabInvoices = this.labInvoices.filter(
          (labInvoice) => +labInvoice.document_id === +this.$route.query.id
        );

        // this.labInvoicesChecks = Object.keys(checkLabInvoices).map(
        //   (index) => +index
        // );
        this.labInvoicesChecks = checkLabInvoices.map((index) => index.ln);

        this.labInvoiceDetailChecks = [];
        this.canLabDetailEdit = false;
        await this.$swal.fire("สำเร็จ", "บันทึกรายการสำเร็จ", "success");
      }
    },
    async resetLabInvoices() {
      this.$store.state.isLoading = true;
      this.isLabInvoiceBusy = true;
      if (this.viewType === "สร้างเอกสาร") {
        try {
          this.labInvoices = await this.getOrderLabInvoice({
            hospitalId: this.hospitalSelected ? this.hospitalSelected.id : null,
            date: this.filterLabDate,
          });
        } catch (e) {
          await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
          this.isLabInvoiceBusy = false;
        }

        // this.labInvoicesChecks = Object.keys(this.labInvoices).map(
        //   (index) => +index
        // );
        this.labInvoicesChecks = this.labInvoices.map(
          (labInvoice) => labInvoice.ln
        );
      } else if (this.viewType === "แก้ไขเอกสาร") {
        let checkLabInvoices = this.labInvoices.filter(
          (labInvoice) => labInvoice.document_id === +this.$route.query.id
        );
        if (checkLabInvoices.length > 0) {
          this.filterLabDate = new Date(
            checkLabInvoices.sort(function(a, b) {
              return new Date(b.orderDate) - new Date(a.orderDate);
            })[0].orderDate
          );
        }
        try {
          this.labInvoices = await this.getOrderLabInvoice({
            hospitalId: this.hospitalSelected ? this.hospitalSelected.id : null,
            documentId: this.$route.query.id,
            date: this.filterLabDate,
          });
        } catch (e) {
          await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
          this.isLabInvoiceBusy = false;
        }

        checkLabInvoices = this.labInvoices.filter(
          (labInvoice) => labInvoice.document_id === +this.$route.query.id
        );

        // this.labInvoicesChecks = Object.keys(checkLabInvoices).map(
        //   (index) => +index
        // );
        this.labInvoicesChecks = checkLabInvoices.map((index) => index.ln);
      }
      this.clearLabInvoiceDetail();
      this.isLabInvoiceBusy = false;
      this.$store.state.isLoading = false;
    },
  },
  watch: {
    labInvoicesChecks(val) {},
    async hospitalSelected(newVal, oldVal) {
      // await this.resetLabInvoices()
      if (newVal) {
        if (!this.$route.query.hasOwnProperty("id")) {
          await this.resetLabInvoices();
        }
      }
    },
    ordersSelected(newVal, oldVal) {
      this.testFilter(newVal, oldVal);
    },
    async hasVat(newVal) {
      if (newVal) {
        this.tiInput = this.tiInput ? this.tiInput : await this.generateTi();
        this.tiDate = new Date();
      } else {
        this.tiInput = null;
        this.tiDate = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.order-table {
  min-height: 200px;
  max-height: 500px;
  overflow: auto;
}
</style>
